import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, UtensilsCrossed } from 'lucide-react';
const symptoms = [{
  title: 'Inflamación Abdominal',
  description: 'Despiertas plana y terminas el día sintiéndote como un globo, sin saber por qué, arruinando tu outfit.',
  icon: Activity
}, {
  title: 'Fatiga Mental',
  description: 'Niebla mental y bajones de energía inexplicables a media tarde, justo cuando más necesitas estar enfocada en tu día a día.',
  icon: Brain
}, {
  title: 'Digestiones Pesadas',
  description: "Incomodidad constante sin importar lo 'limpio' que comas. Tu cuerpo te pide ayuda a gritos.",
  icon: UtensilsCrossed
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function SymptomMatrix() {
  return <section className="py-24 md:py-36 bg-olive" data-id="element-243">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-244">
        <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-245">
          <span className="text-salvia font-semibold tracking-[0.25em] text-xs uppercase mb-4 block" data-id="element-246">
            ¿Te suena familiar?
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1]" data-id="element-247">
            Sabes que algo no va bien, pero{' '}
            <span className="italic font-normal text-forest/70" data-id="element-248">
              nadie te lo soluciona
            </span>
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-249">
          {symptoms.map((symptom, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 md:p-9 rounded-3xl shadow-sm border border-salvia/30" data-id="element-250">
              <div className="w-14 h-14 bg-salvia/20 rounded-2xl flex items-center justify-center mb-6" data-id="element-251">
                <symptom.icon className="w-7 h-7 text-forest" strokeWidth={1.75} data-id="element-252" />
              </div>
              <h3 className="text-xl font-bold text-forest mb-3 tracking-tight" data-id="element-253">
                {symptom.title}
              </h3>
              <p className="text-forest/70 leading-relaxed" data-id="element-254">
                {symptom.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}